import { supabase } from "Infrastructure/Supabase/supabaseClient";
import { useQuery } from "@tanstack/react-query";

export const REGION_TRANSPORT_KEY = "REGION_TRANSPORT";

export const useRegionTransport = (regionCode: string | null | undefined) =>
	useQuery({
		queryKey: [REGION_TRANSPORT_KEY, regionCode],
		queryFn: async () => {
			const { data, error } = await supabase
				.from("cities")
				.select("transport")
				.eq("city_code", regionCode!)
				.maybeSingle();
			if (error) {
				throw error;
			}

			return (data?.transport as string | null) ?? null;
		},
		enabled: !!regionCode,
	});
